<div class="appointment-create-container">
  <!-- Header -->
  <div class="page-header">
    <button class="back-btn" (click)="goBack()">
      <i class="fas fa-arrow-left"></i> Back
    </button>
    <h1>Create Appointment</h1>
  </div>

  <!-- Loading Customer State -->
  <div *ngIf="loadingCustomer" class="loading-state">
    <div class="loading-spinner"></div>
    <span class="loading-text">Loading customer information...</span>
  </div>

  <!-- Error Message -->
  <div *ngIf="errorMessage && !loadingCustomer" class="error-message">
    <i class="fas fa-exclamation-circle"></i>
    {{ errorMessage }}
  </div>

  <!-- Success Message -->
  <div *ngIf="successMessage" class="success-message">
    <i class="fas fa-check-circle"></i>
    {{ successMessage }}
    <p>Redirecting to customers page...</p>
  </div>

  <!-- Form Container -->
  <div *ngIf="!loadingCustomer && customer" class="form-container">
      <form [formGroup]="appointmentForm" (ngSubmit)="onSubmit()">
        <!-- Customer Info -->
        <div class="customer-info" *ngIf="customer">
          <h3>Customer Information</h3>
          <p><strong>Name:</strong> {{ customer.name }}</p>
          <p><strong>Phone:</strong> {{ customer.phoneNumber }}</p>
          <p><strong>Customer ID:</strong> {{ customer.customerId }}</p>
        </div>

        <!-- Address Selection -->
        <div class="address-selection">
          <h3>Select Address</h3>
          <div class="addresses-grid" *ngIf="customerAddresses.length > 0">
            <div 
              *ngFor="let address of customerAddresses" 
              class="address-card"
              [class.selected]="isAddressSelected(address)"
              [class.primary]="address.isPrimary"
              [class.secondary]="!address.isPrimary"
              (click)="selectAddress(address)">
              <div class="address-header">
                <span class="address-type" *ngIf="address.isPrimary">Primary Address</span>
                <span class="address-type" *ngIf="!address.isPrimary">Secondary Address</span>
                <span class="address-badge" [ngClass]="'badge-' + address.addressType.toLowerCase()" *ngIf="address.addressType">
                  <i class="fas" [ngClass]="{'fa-home': address.addressType === 'Home', 'fa-building': address.addressType === 'Office', 'fa-map-marker-alt': address.addressType === 'Other'}"></i>
                  {{ address.addressType }}
                </span>
              </div>
              <div class="address-content">
                <p class="address-text">{{ address.address }}</p>
                <p class="location-info">{{ address.locationName }}</p>
                <p class="pincode">Pincode: {{ address.pincode }}</p>
              </div>
            </div>
          </div>
          <div class="no-addresses" *ngIf="customerAddresses.length === 0">
            <p>No addresses available for this customer.</p>
          </div>
        </div>

        <!-- Appointment Details -->
        <div class="appointment-details" *ngIf="selectedAddress">
          <h3>Appointment Details</h3>
          
          <div class="form-group">
            <label for="date">Date *</label>
            <input 
              type="date" 
              id="date" 
              formControlName="date"
              class="form-control"
              [min]="getCurrentDate()">
          </div>

          <div class="form-group">
            <label for="timeSlot">Time Slot</label>
            <select 
              id="timeSlot" 
              formControlName="timeSlot"
              class="form-control">
              <option value="">Select a time slot</option>
              <option 
                *ngFor="let slot of timeSlotOptions" 
                [value]="slot">
                {{ slot }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label for="address">Address *</label>
            <input 
              type="text" 
              id="address" 
              formControlName="address"
              class="form-control"
              readonly>
          </div>

          <div class="form-group">
            <label for="locationName">Location Name *</label>
            <input 
              type="text" 
              id="locationName" 
              formControlName="locationName"
              class="form-control"
              readonly>
          </div>

          <div class="form-group">
            <label for="geoZoneId">Geo Zone ID *</label>
            <input 
              type="text" 
              id="geoZoneId" 
              formControlName="geoZoneId"
              class="form-control"
              readonly>
          </div>

          <div class="form-group">
            <label for="pincode">Pincode *</label>
            <input 
              type="text" 
              id="pincode" 
              formControlName="pincode"
              class="form-control"
              readonly>
          </div>

          <div class="form-group">
            <label for="remarks">Remarks</label>
            <textarea 
              id="remarks" 
              formControlName="remarks"
              class="form-control"
              rows="3"
              placeholder="Enter any additional remarks..."></textarea>
          </div>

          <!-- Hidden location fields -->
          <div formGroupName="location">
            <input type="hidden" formControlName="latitude">
            <input type="hidden" formControlName="longitude">
          </div>
        </div>

        <!-- Form Actions -->
        <div class="form-actions">
          <button 
            type="button" 
            class="btn btn-secondary" 
            (click)="goBack()"
            [disabled]="creatingAppointment">
            Cancel
          </button>
          <button 
            type="submit" 
            class="btn btn-primary" 
            [disabled]="!appointmentForm.valid || !selectedAddress || creatingAppointment">
            <span *ngIf="creatingAppointment">
              <i class="fas fa-spinner fa-spin"></i> Creating...
            </span>
            <span *ngIf="!creatingAppointment">
              <i class="fas fa-calendar-plus"></i> Create Appointment
            </span>
          </button>
        </div>
      </form>
  </div>
</div>
